import { useContext } from 'react';
import _noop from 'lodash/noop';

import { AppContext, ModalContext } from 'commons-ui';
import { IPermissionHandlerParams } from 'models/settingsV2.model';
import useService from './utils/useService';

const useHandler = (params: IPermissionHandlerParams) => {
	const { setForceUpdate = _noop, rowData } = params;
	const { requestDeletePermissions } = useService();
	const { showAlert, app } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);

	const onAgreeDeletePermission = async () => {
		setModalConfig({ isOpen: false });
		try {
			const response = await requestDeletePermissions(app.appName, rowData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to delete permission');
			}
			showAlert('Permission deleted successfully', { type: 'success' });
			setForceUpdate(true);
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while deleting this permission', { type: 'error' });
		}
	};
	const onDisAgreeDeletePermission = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		onAgreeDeletePermission,
		onDisAgreeDeletePermission
	};
};

export default useHandler;
